import { IntegrationType } from '../types'

export const IntegrationPaths = {
  Table: '/settings/advanced/integrations',
  BucketForm: ({ integrationType, id }: { integrationType?: IntegrationType; id?: string }) =>
    `/settings/advanced/integrations/bucket/${integrationType}/${id || ''}`,
  ExternalIdpForm: (id?: string) => `/settings/advanced/integrations/externalIdp/${id || ''}`,
  WorkloadIdentityFederation: () => `/settings/advanced/integrations/bigquery/workload-identity-federation`,
  DatabricksOAuthU2M: (id?: string) => `/settings/advanced/integrations/databricks/oauth-u2m/${id || ''}`
}
